import { z } from "zod";

export const catalogDetailsQuerySchema = z.object({
  name: z.string().trim().optional(),
  slug: z.string().trim().optional(),
  variant: z.string().trim().optional(),
});

export const catalogChunkQuerySchema = catalogDetailsQuerySchema.extend({
  index: z.coerce.number().int().min(0),
});

export const catalogSubsceneChunkQuerySchema = catalogChunkQuerySchema.extend({
  subsceneKey: z.string().trim().min(1),
});

export const subsceneCatalogItemSchema = z.object({
  subsceneKey: z.string(),
  displayName: z.string(),
  structureKeys: z.array(z.string()),
  versionLabel: z.string(),
  subsceneVersionId: z.string(),
  numberOfChunks: z.unknown(),
  r2ObjectPrefix: z.string().nullable(),
});

export const catalogDetailsPayloadSchema = z.object({
  name: z.string(),
  slug: z.string(),
  displayName: z.string(),
  variant: z.string(),
  version: z.string(),
  versionId: z.string(),
  speciesId: z.string(),
  r2ObjectPrefix: z.string().nullable(),
  config: z.unknown(),
  availableSexes: z.unknown(),
  numberOfChunks: z.unknown(),
  subscenes: z.array(subsceneCatalogItemSchema),
  source: z.literal("catalog_v2"),
});

export const catalogListItemSchema = z.object({
  speciesId: z.string(),
  slug: z.string(),
  displayName: z.string(),
  variants: z.unknown(),
  activeVersionId: z.string().nullable(),
  variantKey: z.string().nullable(),
  versionLabel: z.string().nullable(),
  status: z.string().nullable(),
  previewVersionId: z.string().nullable(),
  previewVersionStatus: z.string().nullable(),
});

export type CatalogDetailsQuery = z.infer<typeof catalogDetailsQuerySchema>;
export type CatalogChunkQuery = z.infer<typeof catalogChunkQuerySchema>;
export type CatalogSubsceneChunkQuery = z.infer<
  typeof catalogSubsceneChunkQuerySchema
>;
export type SubsceneCatalogItem = z.infer<typeof subsceneCatalogItemSchema>;
export type CatalogDetailsPayload = z.infer<typeof catalogDetailsPayloadSchema>;
export type CatalogListItem = z.infer<typeof catalogListItemSchema>;
